import { render, staticRenderFns } from "./CardSubOrder.vue?vue&type=template&id=b68b15aa&"
import script from "./CardSubOrder.vue?vue&type=script&lang=js&"
export * from "./CardSubOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports